var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"svg-style",attrs:{"title":_vm.title}},[_c('svg',{staticClass:"svg-icon",style:(`width: ${_vm.size};height: ${_vm.size};`),attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":_vm.symbolId}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }